module.exports = __webpack_public_path__ + "media/bedroom_music.9383e1b3.mp3";